<template>
	<div class="audio part">
		<div v-html="part.PartEnunciado" class="enunciado">
		</div>
		<div class="perguntas-container">
			<div v-for="(pergunta, index) in part.Perguntas" class="pergunta">
				<div class="enunciado">
					<span>{{ index + 1 }})</span> {{ pergunta.Enunciado }}
				</div>
				<div class="sub-enunciado">
					{{ pergunta.SubEnunciado }}
				</div>
				<div class="opcoes">
					<div v-for="(opcao, oi) in pergunta.Opcoes" 
					class="opcao" :class="{ 'correta': opcao.Correta }">
						<radio 
						@checked="respondeu" 
						:disabled="locked"
						:checked="pergunta.RespostaId == opcao.Id" 
						:name="index" 
						:pergunta="pergunta"
						:value="opcao.Id" 
						:text="opcao.Texto"></radio>
					</div>
				</div>
			</div>
		</div>
		
		<audio-box :part="part" :locked="locked"></audio-box>
	</div>
</template>


<script>
	import bus from '@/bus/event-bus.js'
	import AudioBox from './AudioBox'
	export default {
		props: ['part', 'locked'],
		components: {
			'audio-box': AudioBox
		},
		methods: {
			respondeu(opcaoId, perguntaId) {
				var pergunta = this.getPerguntaById(perguntaId)
				pergunta.RespostaId = opcaoId

				if(opcaoId != null) {
					bus.$emit('respondeu', opcaoId, pergunta.Id)
				}
			},

			getPerguntaById(id) {
				var pergunta = this.part.Perguntas.find((p) => {
					return p.Id == id
				})

				return pergunta
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/audio/Pergunta.vue